import { TextField, MenuItem } from '@mui/material';
import { DEFAULT_PROPS } from '../Constants';

export const SourceColumnField = ({
  value,
  onChange,
  headers,
  helperText,
  error,
  disabled = DEFAULT_PROPS.disabled,
}) => (
  <TextField
    select
    fullWidth
    label="Source Column *"
    value={value}
    onChange={onChange}
    disabled={disabled}
    size="small"
    error={!!error}
    helperText={helperText}
  >
    <MenuItem value="" disabled>
      Select a column
    </MenuItem>
    {headers.map((header) => (
      <MenuItem key={header.label} value={header.label}>
        {header.label}
      </MenuItem>
    ))}
  </TextField>
);
